import {
  SET_LANDING_SEARCH_STRING,
  CLEAR_LANDING_SEARCH_STRING,
  GET_APP_CONFIG_SUCCESS,
  GET_ETH_VS_USD_CONVERTER_FAILURE,
  GET_ETH_VS_USD_CONVERTER_SUCCESS,
  GET_APP_CONFIG_REQUEST,
} from 'redux/actionTypes/generalActionTypes';
import { mergeToken } from '../../services/assetsService';

const INITIAL_STATE = {
  landingSearchString: '',
};

export default (state = INITIAL_STATE, action) => {
  const { type, payload } = action;

  switch (type) {
    case SET_LANDING_SEARCH_STRING:
      return {
        ...state,
        landingSearchString: payload,
      };

    case CLEAR_LANDING_SEARCH_STRING:
      return {
        ...state,
        landingSearchString: '',
      };
    case GET_APP_CONFIG_REQUEST:
      return {
        ...state,
        tokens: null,
      };
    case GET_APP_CONFIG_SUCCESS:
      return {
        ...state,
        scan: payload.scan,
        requiredTokens: payload.required_tokens,
        tokens: Object.values(payload.tokens).reduce((acc, curr) => {
          acc[curr.symbol] = mergeToken(curr);
          return acc;
        }, {}),
      };

    case GET_ETH_VS_USD_CONVERTER_SUCCESS:
      return {
        ...state,
        converter: {
          ...state.converter,
          [action.name]: action.payload,
        },
      };

    case GET_ETH_VS_USD_CONVERTER_FAILURE:
      return {
        ...state,
        converter: {
          error: action.payload,
        },
      };

    default:
      return state;
  }
};
